import type { MeResponse, UpdateProfileRequest } from '@/js/account/shared/model';
import { accountHttp } from '@/js/account/shared/api';

export async function accountMeUpdate(
  payload: UpdateProfileRequest,
): Promise<MeResponse> {
  const { data } = await accountHttp.patch<MeResponse>('/me', payload);
  return data;
}

export async function accountMeAvatarUpdate(file: File): Promise<MeResponse> {
  const formData = new FormData();
  formData.append('avatar', file);

  const { data } = await accountHttp.post<MeResponse>('/me/avatar', formData);
  return data;
}

export async function accountMeAvatarClear(): Promise<MeResponse> {
  const { data } = await accountHttp.delete<MeResponse>('/me/avatar');
  return data;
}
